import { darkColors, StyledButton } from '@tryhackme/thm-ui-components';
import { useNavigate } from 'react-router-dom';
import { useFeatureIsOn } from 'src/common/growthbook';
import { useGetUserQuery, useTrackCTAClickMutation } from 'src/common/slices';
import { anonymousId } from 'src/common/tracking/data';
import { ThemeProvider, useTheme } from 'styled-components';
import { useActiveCampaign } from '../../hooks/use-active-campaign';
import { LeftRays, LeftStars, RightStars, StyledBarAlt, StyledImageWrapRow, StyledTextAlt, StyledTitle, StyledTreasureChestImg, StyledWrapRow } from './top-bar.styles';
export const TicketingEventEmbeddedBarNoSale = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [trackCTAClick] = useTrackCTAClickMutation();
  const handleLearnMore = async () => {
    try {
      await trackCTAClick({
        button_text: 'Learn more',
        page: 'Why Subscribe - hack2win banner',
        anonymousId
      }).unwrap();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to track learn more click', error);
    } finally {
      navigate('/hack2win');
    }
  };
  const {
    data: userData
  } = useGetUserQuery();
  const {
    campaign,
    isLoading
  } = useActiveCampaign();
  const isFlashSaleActive = Boolean(campaign?.isFlashSale);
  const isTicketingEventEnabled = useFeatureIsOn('new-ticketing-event');
  const isPremium = userData?.data?.user?.isPremium;
  if (!isTicketingEventEnabled) return null;
  if (isLoading || isFlashSaleActive) return null;
  if (isPremium) return null;
  return <ThemeProvider theme={{
    ...theme,
    colors: darkColors
  }} data-sentry-element="ThemeProvider" data-sentry-component="TicketingEventEmbeddedBarNoSale" data-sentry-source-file="top-bar-no-sale.tsx">
      <StyledBarAlt data-testid="campaign-bar-no-sale" data-sentry-element="StyledBarAlt" data-sentry-source-file="top-bar-no-sale.tsx">
        <LeftRays data-sentry-element="LeftRays" data-sentry-source-file="top-bar-no-sale.tsx" />
        <LeftStars data-sentry-element="LeftStars" data-sentry-source-file="top-bar-no-sale.tsx" />
        <RightStars data-sentry-element="RightStars" data-sentry-source-file="top-bar-no-sale.tsx" />
        <StyledWrapRow data-sentry-element="StyledWrapRow" data-sentry-source-file="top-bar-no-sale.tsx">
          <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="top-bar-no-sale.tsx">
            <StyledTextAlt data-sentry-element="StyledTextAlt" data-sentry-source-file="top-bar-no-sale.tsx">
              Power up your chances to win the TryWinMe Raffle prizes! Premium users earn <span>2 tickets</span> per
              room.{' '}
              <StyledButton onClick={handleLearnMore} variant="text" color="info" data-sentry-element="StyledButton" data-sentry-source-file="top-bar-no-sale.tsx">
                Learn more
              </StyledButton>
            </StyledTextAlt>
          </StyledTitle>
        </StyledWrapRow>
        <StyledImageWrapRow data-sentry-element="StyledImageWrapRow" data-sentry-source-file="top-bar-no-sale.tsx">
          <StyledTreasureChestImg data-sentry-element="StyledTreasureChestImg" data-sentry-source-file="top-bar-no-sale.tsx" />
        </StyledImageWrapRow>
      </StyledBarAlt>
    </ThemeProvider>;
};